module.exports = __webpack_public_path__ + "static/media/ic_trade_unlimited.50822931.svg";